/**
 * ArtifactLinks — renders machine-produced turn artifacts as real UI elements.
 *
 * Today the only artifact kind is `downloadUrl`, rendered as an anchor whose
 * href is the verbatim `Artifact.url`. The href deliberately never passes
 * through a markdown/text-rendering path — that is the entire point of the
 * artifact channel: presigned S3 URLs must reach the user uncorrupted, not
 * transcribed (and possibly mangled) into the model's answer text.
 */
import React from 'react';
import type { Artifact } from '@amzn/soda-brain-protocol';
import type { ThemeColors } from './useTheme';

export function ArtifactLinks({ artifacts, colors }: { artifacts: Artifact[]; colors: ThemeColors }): React.ReactElement | null {
  const downloadLinks = artifacts.filter((a) => a.type === 'downloadUrl');
  if (downloadLinks.length === 0) return null;

  return (
    <div style={{ marginTop: '8px', display: 'flex', flexDirection: 'column', gap: '6px', alignItems: 'flex-start' }}>
      {downloadLinks.map((artifact, i) => (
        <a
          key={i}
          href={artifact.url}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            padding: '6px 12px',
            borderRadius: '16px',
            border: `1px solid ${colors.suggestionBorder}`,
            background: colors.suggestionBg,
            color: colors.suggestionText,
            fontSize: '13px',
            textDecoration: 'none',
          }}
        >
          ⬇️ {artifact.label}
        </a>
      ))}
    </div>
  );
}
